import artifact from '$houdini/artifacts/UpdateItinerariesFavorite'
import { MutationStore } from '../runtime/stores/mutation'

export class UpdateItinerariesFavoriteStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
